import React from "react";
import { Container } from "reactstrap";
import { Link } from "react-router-dom";
import FooterBlack from "components/Footers/FooterBlack.js";

function OpenSource() {
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="edge-page">
      <div className="edge-page-brand-nav">
        <Container>
          <Link to="/presentation">Edge<span>Ventures</span></Link>
        </Container>
      </div>
      <section className="edge-page-hero">
        <Container>
          <span className="edge-page-eyebrow">{"// community"}</span>
          <h1 className="edge-page-title">
            Open <span>Source</span>
          </h1>
          <p className="edge-page-subtitle">
            Tools, templates, and libraries we've built and released publicly.
            Built in the open, used in production.
          </p>
          <a
            href="https://github.com/Edge-Ventures/"
            target="_blank"
            rel="noopener noreferrer"
            className="ep-btn-primary"
          >
            View on GitHub →
          </a>
        </Container>
      </section>

      <section className="edge-page-body">
        <Container>
          <div className="edge-stub-card">
            <div className="edge-stub-icon">
              <svg width="24" height="24" fill="none" stroke="currentColor" strokeWidth="1.8" viewBox="0 0 24 24">
                <path d="M9 19c-5 1.5-5-2.5-7-3m14 6v-3.87a3.37 3.37 0 0 0-.94-2.61c3.14-.35 6.44-1.54 6.44-7A5.44 5.44 0 0 0 20 4.77 5.07 5.07 0 0 0 19.91 1S18.73.65 16 2.48a13.38 13.38 0 0 0-7 0C6.27.65 5.09 1 5.09 1A5.07 5.07 0 0 0 5 4.77a5.44 5.44 0 0 0-1.5 3.78c0 5.42 3.3 6.61 6.44 7A3.37 3.37 0 0 0 9 18.13V22"/>
              </svg>
            </div>
            <h3>Project showcase coming soon</h3>
            <p>
              We're organizing our public repositories into a proper showcase.
              For now, browse our GitHub organization to see what we've shipped.
            </p>
            <a
              href="https://github.com/Edge-Ventures/"
              target="_blank"
              rel="noopener noreferrer"
              className="ep-btn-primary"
            >
              github.com/Edge-Ventures
            </a>
          </div>
        </Container>
      </section>

      <FooterBlack />
    </div>
  );
}

export default OpenSource;
